import React, { memo } from 'react';
import {
  BannerDisplayIntent,
  BannerDisplayProduct,
} from '@services/types/General/banners';
import { UnorderedListOutlined } from '@ant-design/icons';
import { Button, List, Popover } from 'antd';
import { useTranslation } from 'react-i18next';

interface BannerRecipientsColProps {
  type: BannerDisplayIntent;
  product: BannerDisplayProduct;
  customers: any[];
}

const BannerRecipientsCol = ({
  type,
  product,
  customers,
}: BannerRecipientsColProps) => {
  const { t } = useTranslation(['banners', 'main']);

  if (type === 'SELECTED') {
    return (
      <Popover
        content={
          <List
            dataSource={customers}
            renderItem={item => (
              <List.Item style={{ fontSize: '0.8rem' }}>
                {`${item.id} - ${item.name}`}
              </List.Item>
            )}
          />
        }
      >
        <Button type="link" icon={<UnorderedListOutlined />}>
          {t('columns.recipients.types.SELECTED')}
        </Button>
      </Popover>
    );
  }
  if (type === 'ALL' && product === 'ALL') {
    return <span>{t('columns.recipients.types.ALL')}</span>;
  }
  const recipientsTypeTranslation = t(`columns.recipients.types.${type}`);
  const productTranslation =
    product !== 'ALL' && t(`main:apps.${product?.toLowerCase()}`);
  return (
    <span>
      {`${recipientsTypeTranslation}${
        productTranslation ? ` (${productTranslation})` : ''
      }`}
    </span>
  );
};

export default memo(BannerRecipientsCol);
